import jwtService from "./jwtService";
import authApi from "./authApi";

/**
 * High-level authentication service
 */
const authService = {
  signIn: async (email, password) => {
    try {
      const response = await authApi.login(email, password);

      if (response.token) {
        jwtService.setToken(response.token);
        jwtService.setRefreshToken(response.refreshToken);
      }

      return response;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },

  signUp: async (userData) => {
    try {
      return await authApi.register(userData);
    } catch (error) {
      console.error("Registration error:", error);
      throw error;
    }
  },

  refreshToken: async () => {
    try {
      const refreshToken = jwtService.getRefreshToken();
      if (!refreshToken) {
        throw new Error("No refresh token available");
      }

      const response = await authApi.refreshToken(refreshToken);
      if (response.accessToken) {
        jwtService.setToken(response.accessToken);
      }

      return response;
    } catch (error) {
      console.error("Token refresh error:", error);
      await authService.logout();
      throw error;
    }
  },

  logout: async () => {
    try {
      const user = jwtService.getUserInfo();

      if (user && user.id) {
        await authApi.logout(user.id);
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      jwtService.removeTokens();
    }
  },

  isAuthenticated: () => {
    return jwtService.isAuthenticated();
  },

  hasRole: (role) => {
    return jwtService.hasRole(role);
  },

  changePassword: async (oldPassword, newPassword) => {
    try {
      return await authApi.changePassword(oldPassword, newPassword);
    } catch (error) {
      console.error("Change password error:", error);
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      return await authApi.forgotPassword(email);
    } catch (error) {
      console.error("Forgot password error:", error);
      throw error;
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      return await authApi.resetPassword(token, newPassword);
    } catch (error) {
      console.error("Reset password error:", error);
      throw error;
    }
  },
};

export default authService;
